import { Patient } from '@dataTypes/billing.types'

export interface RawPatientFromApi {
  patient_id?: string
  first_name?: string
  last_name?: string
  date_of_birth?: string
}

export function mapPatientsFromApi(
  patients: RawPatientFromApi[] | undefined,
): Patient[] {
  if (!Array.isArray(patients)) return []
  return patients.map((p) => ({
    patientId: p.patient_id ?? '',
    patientName: `${p.first_name ?? ''} ${p.last_name ?? ''}`.trim(),
    dateOfBirth: p.date_of_birth ?? '',
  }))
}
